import React, { FC, useEffect, useMemo, useState } from "react";
import { Description } from "@evergis/ui";
import { useMapContext } from "@evergis/react";
import { area as calcArea, length as calcLength } from "@evergis/sgis/es/geotools";
import { useTranslation } from "react-i18next";
import { Coordinates } from "@evergis/sgis/es/baseTypes";

import { PopupContainer } from "./styled";

import { POLYGON_LIKE_TOOLS } from "./constants";

import { useGeometrySelection } from "../../../../hooks/geometrySelection/useGeometrySelection";
import { formatArea, formatLength } from "../../../../react-sgis/utils";

export const GeometryInfo: FC = () => {
  const { t } = useTranslation("mapControls");
  const [{ history, type }] = useGeometrySelection();
  const { map } = useMapContext();
  const [result, setResult] = useState<number[]>([0, 0]);
  const isPolygonLike = useMemo(() => POLYGON_LIKE_TOOLS.includes(type), [type]);

  useEffect(() => {
    if (history.step === -1) {
      return;
    }

    if (isPolygonLike) {
      setResult(
        history.features[history.step].reduce(
          (acc, curr) => {
            return [
              acc[0] + calcArea(curr._rings as Coordinates[][], map.crs),
              acc[1] + calcLength(curr._rings as Coordinates[][], map.crs, true),
            ];
          },
          [0, 0],
        ),
      );
    } else {
      setResult(
        history.features[history.step].reduce(
          (acc, curr) => {
            return [acc[0] + calcLength(curr._rings as Coordinates[][], map.crs, true)];
          },
          [0],
        ),
      );
    }
  }, [history]); // eslint-disable-line

  return (
    <PopupContainer width="12rem">
      <Description>{isPolygonLike ? t("geometrySelectionTerritory") : t("geometrySelectionLength")}</Description>
      {isPolygonLike ? (
        <>
          <div>S : {formatArea(result[0])}</div>
          <div>P : {formatLength(result[1])}</div>
        </>
      ) : (
        <div>{formatLength(result[0])}</div>
      )}
    </PopupContainer>
  );
};
